import { ToggleButtonGroup, ToggleButton } from '@collaborate-health/uikit'

import { Scope } from '../../enums'

export interface ScopeSelectorProps {
  value: Scope
  onChange: (scope: Scope) => void
}

const ScopeSelector: React.FC<ScopeSelectorProps> = ({ value, onChange }) => {
  return (
    <ToggleButtonGroup value={value} exclusive onChange={(_, newScope) => onChange(newScope ?? Scope.Tenant)}>
      <ToggleButton value={Scope.Tenant}>Tenant</ToggleButton>
      <ToggleButton value={Scope.Corporation}>Corporation</ToggleButton>
    </ToggleButtonGroup>
  )
}

export default ScopeSelector

